import ContainerHeader from 'components/ContainerHeader';
import WithAddableInputFormTemplate from 'routes/Profile/components/ProfileContent/WithAddableInputFormTemplate';
import styled from 'styled-components';

export const MobileContainerHeaderStyled = styled(ContainerHeader)`
  padding: 15px;
  background: white;
  min-height: 66px;
  border-bottom: 1px solid #dedede;
`;

export const WithAddableInputFormTemplateStyled = styled(WithAddableInputFormTemplate)`
  & .addable-input-element-container {
    padding-bottom: 8px !important;
  }
`;
